// extracted by mini-css-extract-plugin
module.exports = {"handler":"SimpleHandler_handler__3pxut","withOpenIndicators":"SimpleHandler_withOpenIndicators__CxAfO","header":"SimpleHandler_header__2-_P5"};